// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"policy_checkbox_checkboxContainer__jKGUX","policyText":"policy_checkbox_policyText__cn4mm"};